webpackJsonp([96961042003272],{

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  max-width: ', ';\n  padding: 3em 1.5em 2em;\n'], ['\n  margin: 0 auto;\n  max-width: ', ';\n  padding: 3em 1.5em 2em;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.section(_templateObject, function (props) {
	  return props.theme.sizes.maxWidth;
	});
	
	var Container = function Container(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    props.children
	  );
	};
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  max-width: ', ';\n  text-align: center;\n\n  h1,\n  h2,\n  h3 {\n    font-weight: 600;\n    line-height: 1.25;\n    margin: 0 0 1rem 0;\n    text-transform: capitalize;\n  }\n\n  h1 {\n    font-size: 1.5em;\n  }\n  h2 {\n    font-size: 1.25em;\n  }\n  h3 {\n    font-size: 1em;\n  }\n\n  p {\n    line-height: ', ';\n    margin: 0 0 2em 0;\n    font-style: italic;\n    font-size: ', ';\n  }\n\n  a {\n    transition: 0.2s;\n    color: ', ';\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  del {\n    text-decoration: line-through;\n  }\n  strong {\n    font-weight: 600;\n  }\n  em {\n    font-style: italic;\n  }\n\n  ul,\n  ol {\n    margin: 0 0 2em 0;\n  }\n\n  ul {\n    li {\n      list-style: disc;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {\n        margin: 0;\n      }\n    }\n  }\n\n  ol {\n    li {\n      list-style: decimal;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {\n        margin: 0;\n      }\n    }\n  }\n\n  hr {\n    border-style: solid;\n    border-color: ', ';\n    margin: 0 0 2em 0;\n  }\n\n  blockquote {\n    font-style: italic;\n    border-left: 4px solid ', ';\n    padding: 0 0 0 0.5em;\n  }\n\n  pre {\n    margin: 0 0 2em 0;\n    border-radius: 2px;\n    background: ', ' !important;\n    span {\n      background: inherit !important;\n    }\n  }\n'], ['\n  margin: 0 auto;\n  max-width: ', ';\n  text-align: center;\n\n  h1,\n  h2,\n  h3 {\n    font-weight: 600;\n    line-height: 1.25;\n    margin: 0 0 1rem 0;\n    text-transform: capitalize;\n  }\n\n  h1 {\n    font-size: 1.5em;\n  }\n  h2 {\n    font-size: 1.25em;\n  }\n  h3 {\n    font-size: 1em;\n  }\n\n  p {\n    line-height: ', ';\n    margin: 0 0 2em 0;\n    font-style: italic;\n    font-size: ', ';\n  }\n\n  a {\n    transition: 0.2s;\n    color: ', ';\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  del {\n    text-decoration: line-through;\n  }\n  strong {\n    font-weight: 600;\n  }\n  em {\n    font-style: italic;\n  }\n\n  ul,\n  ol {\n    margin: 0 0 2em 0;\n  }\n\n  ul {\n    li {\n      list-style: disc;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {\n        margin: 0;\n      }\n    }\n  }\n\n  ol {\n    li {\n      list-style: decimal;\n      list-style-position: inside;\n      line-height: 1.25;\n      &:last-child {\n        margin: 0;\n      }\n    }\n  }\n\n  hr {\n    border-style: solid;\n    border-color: ', ';\n    margin: 0 0 2em 0;\n  }\n\n  blockquote {\n    font-style: italic;\n    border-left: 4px solid ', ';\n    padding: 0 0 0 0.5em;\n  }\n\n  pre {\n    margin: 0 0 2em 0;\n    border-radius: 2px;\n    background: ', ' !important;\n    span {\n      background: inherit !important;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	__webpack_require__(53);
	
	var Body = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.sizes.maxWidthCentered;
	}, function (props) {
	  return props.big ? "1.3" : "1.6";
	}, function (props) {
	  return props.big ? "22px" : "15px";
	}, function (props) {
	  return props.theme.colors.base;
	}, function (props) {
	  return props.theme.colors.highlight;
	}, function (props) {
	  return props.theme.colors.secondary;
	}, function (props) {
	  return props.theme.colors.secondary;
	}, function (props) {
	  return props.theme.colors.secondary;
	});
	
	var PageBody = function PageBody(props) {
	  return _react2.default.createElement(Body, {
	    big: props.big,
	    dangerouslySetInnerHTML: { __html: props.body.childMarkdownRemark.html }
	  });
	};
	
	exports.default = PageBody;
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(18);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        pagePath = _props.pagePath,
	        postSEO = _props.postSEO,
	        pageSEO = _props.pageSEO,
	        customTitle = _props.customTitle;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var imgWidth = void 0;
	    var imgHeight = void 0;
	    var pageUrl = void 0;
	
	    // Set Default OpenGraph Parameters for Fallback
	    title = _siteConfig2.default.siteTitle;
	    description = _siteConfig2.default.siteDescription;
	    image = _siteConfig2.default.siteUrl + _siteConfig2.default.shareImage;
	    imgWidth = _siteConfig2.default.shareImageWidth;
	    imgHeight = _siteConfig2.default.shareImageHeight;
	    pageUrl = _siteConfig2.default.siteUrl;
	
	    if (customTitle) {
	      title = postNode.title;
	      pageUrl = _siteConfig2.default.siteUrl + '/' + pagePath + '/';
	    }
	
	    // Replace with Page Parameters if post or page
	    if (postSEO || pageSEO) {
	      title = postNode.title;
	      description = postNode.metaDescription === null ? postNode.body.childMarkdownRemark.excerpt : postNode.metaDescription.internal.content;
	
	      pageUrl = _siteConfig2.default.siteUrl + '/' + pagePath + '/';
	    }
	    // Use Hero Image for OpenGraph
	    if (postSEO) {
	      image = 'https:' + postNode.heroImage.ogimg.src;
	      imgWidth = postNode.heroImage.ogimg.width;
	      imgHeight = postNode.heroImage.ogimg.height;
	    }
	
	    // Default Website Schema
	    var schemaOrgJSONLD = [{
	      '@context': 'http://schema.org',
	      '@type': 'WebSite',
	      url: _siteConfig2.default.siteUrl,
	      name: _siteConfig2.default.siteTitle,
	      alternateName: _siteConfig2.default.siteTitleAlt ? _siteConfig2.default.siteTitleAlt : ''
	    }];
	
	    // Blog Post Schema
	    if (postSEO) {
	      schemaOrgJSONLD.push({
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            '@id': _siteConfig2.default.siteUrl,
	            name: _siteConfig2.default.siteTitle
	          }
	        }, {
	          '@type': 'ListItem',
	          position: 2,
	          item: {
	            '@id': pageUrl,
	            name: title
	          }
	        }]
	      }, {
	        '@context': 'http://schema.org',
	        '@type': 'BlogPosting',
	        url: pageUrl,
	        name: title,
	        alternateName: _siteConfig2.default.siteTitleAlt ? _siteConfig2.default.siteTitleAlt : '',
	        headline: title,
	        image: {
	          '@type': 'ImageObject',
	          url: image,
	          width: imgWidth,
	          height: imgHeight
	        },
	        author: {
	          '@type': 'Person',
	          name: _siteConfig2.default.author,
	          url: _siteConfig2.default.authorUrl
	        },
	        publisher: {
	          '@type': 'Organization',
	          name: _siteConfig2.default.publisher,
	          url: _siteConfig2.default.siteUrl
	        },
	        datePublished: postNode.publishDateISO,
	        mainEntityOfPage: pageUrl
	      });
	    }
	
	    // Page SEO Schema
	    if (pageSEO) {
	      schemaOrgJSONLD.push({
	        '@context': 'http://schema.org',
	        '@type': 'WebPage',
	        url: pageUrl,
	        name: title
	      });
	    }
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:url', content: pageUrl }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', { property: 'og:image:width', content: imgWidth }),
	      _react2.default.createElement('meta', { property: 'og:image:height', content: imgHeight }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:creator',
	        content: _siteConfig2.default.userTwitter ? _siteConfig2.default.userTwitter : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(18);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(43);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PageBody = __webpack_require__(44);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	var _SEO = __webpack_require__(45);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTemplate = function PageTemplate(_ref) {
	  var data = _ref.data;
	  var _data$contentfulPage = data.contentfulPage,
	      title = _data$contentfulPage.title,
	      slug = _data$contentfulPage.slug,
	      body = _data$contentfulPage.body;
	
	  var postNode = data.contentfulPage;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        title + ' - ' + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { pagePath: slug, postNode: postNode, pageSEO: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_PageBody2.default, { body: body })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = PageTemplate;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  siteTitle: 'Aston Villa',
	  siteTitleAlt: 'Hotell Aston Villa Göteborg', // This allows an alternative site title for SEO schema.
	  publisher: 'Aston Villa', // Organization name used for SEO schema
	  siteDescription: 'Litet, klassiskt hotell i Göteborg',
	  siteUrl: 'https://astonvilla.se', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
	  author: 'GCN User', // Author for RSS author segment and SEO schema
	  authorUrl: 'https://gcn.netlify.com/about/', // URL used for author and publisher schema, can be a social profile or other personal site
	  userTwitter: '@twitter', // Change for Twitter Cards
	  shortTitle: 'Aston Villa', // Used for App manifest e.g. Mobile Home Screen
	  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
	  shareImageWidth: 900, // Change to the width of your default share image
	  shareImageHeight: 600, // Change to the height of your default share image
	  siteLogo: '/logos/logo.jpg', // Logo used for SEO, RSS, and App manifest
	  backgroundColor: '#ffffff', // Used for Offline Manifest
	  themeColor: '#aaaaaa', // Used for Offline Manifest
	  copyright: 'Copyright © 2018 Aston Villa' // Copyright string for the RSS feed
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-19b292130ea98c5a9dc8.js